<div class="course-offering-group-list pb-16">
    <mat-card class="course-offering-card pointer mat-elevation-z" *ngFor="let offering of offerringGroupOfferings; first as isFirst; last as isLast">
        <div class="course-offering-image-container mr-16">
            <div
                class="course-offering-image"
                [ngStyle]="offering.image && { background: 'url(' + offering.image.smallUrl + ') center / cover no-repeat ' }"
                [class.no-image]="!offering.image"
            >
                <img style="display: none" *ngIf="offering.image && offering.image.unsplash" [src]="unsplashViewsBaseUrl + offering.image.unsplash.unsplashId" />

                <mat-icon class="bg-icon" svgIcon="bg_illustration" *ngIf="!offering.image"> </mat-icon>
            </div>
        </div>
        <mat-card-content fxLayout="row" fxLayoutAlign="space-between center">
            <div fxLayout="row" fxLayoutAlign="flex-start center" class="course-offering-title pr-16">
                <mat-icon class="mr-8" [svgIcon]="offering.postingType.name | getPostingIcon"></mat-icon>
                <div fxLayout="column">
                    <h2 class="my-0">{{ offering.translation.title }}</h2>
                    <mat-chip-set class="chip-list wrap">
                        <mat-chip class="chip accent-500" [disableRipple]="true">
                            {{ offering.postingType.displayNameKeySingular | translate }}
                        </mat-chip>
                    </mat-chip-set>
                </div>
            </div>
            <div class="course-offering-actions" fxLayout="row" fxLayoutAlign="end center">
                <ng-container *ngIf="isSelectable">
                    <app-flat-button
                        [label]="'GENERAL.BUTTON.SELECT'"
                        (onClick)="onSelectCourseOffering(offering); $event.stopPropagation()"
                        [disabled]="isSelectDisabled"
                        *ngIf="!offering.isSelected; else unselect"
                    ></app-flat-button>

                    <ng-template #unselect>
                        <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="onDeselectCourseOffering(offering); $event.stopPropagation()"></app-white-button>
                    </ng-template>
                </ng-container>
            </div>
        </mat-card-content>
    </mat-card>
</div>
